import React from 'react';
import { Form, Modal, Checkbox } from 'antd';
import { isEmpty, pickBy, get } from 'lodash';
import { translate } from 'react-i18next';
import i18next from 'i18next';

import TextField from 'Parts/ui/components/fields/TextField';
import CountryField from 'Parts/ui/components/fields/CountryField';
import ProvinceField from 'Parts/ui/components/fields/ProvinceField';
import PostalCodeField from 'Parts/ui/components/fields/PostalCodeField';
import AddressField from 'Parts/ui/components/fields/AddressField';
import CityField from 'Parts/ui/components/fields/CityField';
import NameField from 'Parts/ui/components/fields/NameField';
import CancelAndSaveButtons from 'Parts/ui/components/CancelAndSaveButtons';
import FundkyButton from 'Parts/ui/components/FundkyButton';

import { customFieldValidator } from 'Parts/ui/validations/fieldValidations';

import TaxReceiptAdminConfigurationOrganizationDetailsForm_en from './locales/TaxReceiptAdminConfigurationOrganizationDetailsForm_en.json';
import TaxReceiptAdminConfigurationOrganizationDetailsForm_fr from './locales/TaxReceiptAdminConfigurationOrganizationDetailsForm_fr.json';

import './TaxReceiptAdminConfigurationOrganizationDetailsForm.less';

class TaxReceiptAdminConfigurationOrganizationDetailsForm extends React.Component {
  constructor(props) {
    super(props);

    if (!props.countries || isEmpty(props.countries)) this.props.fetchCountries();

    if (!props.provinces || isEmpty(props.provinces)) this.props.fetchProvinces();

    this.state = {
      country: get(props, 'organization.information.country', null),
      displayActionModal: false,
      acceptModification: false
    };

    i18next.addResourceBundle(
      'en',
      'TaxReceiptAdminConfigurationOrganizationDetailsForm',
      TaxReceiptAdminConfigurationOrganizationDetailsForm_en
    );
    i18next.addResourceBundle(
      'fr',
      'TaxReceiptAdminConfigurationOrganizationDetailsForm',
      TaxReceiptAdminConfigurationOrganizationDetailsForm_fr
    );
  }

  handleSubmit = event => {
    event.preventDefault();

    const { validateFields, getFieldsValue, isFieldTouched } = this.props.form;
    // The force option is required because we have dynamic rules
    // See https://github.com/react-component/form/issues/130
    validateFields({ force: true }, (err, allValues) => {
      if (!err) {
        const updatedValues = pickBy(allValues, (value, key) => isFieldTouched(key));
        delete updatedValues['TaxReceiptAdminConfigurationOrganizationDetailsForm-acceptCheckbox'];
        let countryCP = null;

        if (updatedValues && !this.isEmpty(updatedValues)) {
          countryCP = {
            postalCode: allValues.postalCode,
            country: allValues.country
          };
        }

        const values = {
          ...updatedValues,
          ...countryCP
        };

        this.props.updateTaxReceiptConfigurationOrganizationDetails(
          values,
          (this.props.configuration && this.props.configuration.statusId) || undefined
        );
        this.props.form.resetFields([
          'TaxReceiptAdminConfigurationOrganizationDetailsForm-acceptCheckbox'
        ]);
        this.hideActionModal();
      }
    });
  };

  isEmpty = obj => {
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  };

  handleCancel = event => {
    event.preventDefault();
    this.props.form.resetFields();
  };

  onCountryChange = value => {
    this.setState({
      country: value
    });
  };

  showActionModal = () => {
    this.setState({
      displayActionModal: true
    });
  };

  hideActionModal = () => {
    this.setState({
      displayActionModal: false,
      acceptModification: false
    });
  };

  handleCheckboxChange = event => {
    const value = event.target.checked;
    this.setState({
      acceptModification: value
    });
  };

  handleModalAccept = event => {
    this.handleSubmit(event);
  };

  handleModalCancel = event => {
    this.props.form.resetFields([
      'TaxReceiptAdminConfigurationOrganizationDetailsForm-acceptCheckbox'
    ]);
    this.hideActionModal();
  };

  render() {
    const { t, locale, form, organization } = this.props;
    const { country } = this.state;
    const craRegex = /^[0-9]{9}[A-Z]{2}[0-9]{4}$/g;

    const modificationModal = (
      <Modal
        className="TaxReceiptAdminConfigurationPanel--Modal"
        visible={this.state.displayActionModal ? true : false}
        footer={null}
        onCancel={this.handleModalCancel}
        maskClosable
      >
        <FundkyButton
          className="TaxReceiptAdminConfigurationPanel--closeModal"
          type="text"
          icon={['fas', 'times']}
          size="large"
          action={{ func: this.handleModalCancel }}
        />
        <h1>{t('modification')}</h1>
        <p>{t('modification-description')}</p>
        <Form.Item>
          {this.props.form.getFieldDecorator(
            'TaxReceiptAdminConfigurationOrganizationDetailsForm-acceptCheckbox',
            { onChange: this.handleCheckboxChange }
          )(
            <Checkbox checked={this.state.acceptModification}>
              {t('modification-checkbox')}
            </Checkbox>
          )}
        </Form.Item>

        <div className="TaxReceiptAdminConfigurationPanel--buttons">
          <FundkyButton
            className=""
            type="cancel"
            text={t('cancel')}
            size="medium"
            action={{ func: this.handleModalCancel }}
          />
          <FundkyButton
            className=""
            type="primary"
            text={t('accept')}
            size="medium"
            loading={this.props.isUpdateConfigurationInProgress}
            action={{ func: this.handleModalAccept }}
            disabled={!this.state.acceptModification}
          />
        </div>
      </Modal>
    );

    return (
      <Form className="TaxReceiptAdminConfigurationOrganizationDetailsForm">
        <p>{t('important-notice')}</p>
        <TextField
          form={form}
          label={t('registration-number')}
          fieldId={'registrationNumber'}
          initialValue={get(organization, 'profiles.general.registrationNumber')}
          maxlength={15}
          counter={true}
          hasFeedback
          fieldOptions={{
            rules: [
              ...customFieldValidator(
                true,
                t('cra-required'),
                craRegex,
                t('cra-validation'),
                15,
                15,
                null
              )
            ]
          }}
          uppercase
          onInput={this.updateSerialNumber}
        />
        <NameField
          initialValue={get(organization, 'name')}
          maxlength={75}
          counter={true}
          form={form}
          fieldId="name"
          required={true}
          placeholder={false}
          label={t('Name')}
          identity="organization"
        />
        <p>
          <strong>{t('address-block')}</strong>
        </p>
        <CountryField
          initialValue={get(organization, 'profiles.general.country')}
          form={form}
          onChangeHandler={this.onCountryChange}
          countries={this.props.countries}
          locale={locale}
          identity="organization"
        />
        <AddressField
          className=""
          initialValue={get(organization, 'profiles.general.address')}
          form={form}
          label={true}
          placeholder={false}
          required={true}
          identity="organization"
        />
        <CityField
          className=""
          initialValue={get(organization, 'profiles.general.city')}
          form={form}
          label={true}
          placeholder={false}
          required={true}
          identity="organization"
        />
        <ProvinceField
          className=""
          initialValue={get(organization, 'profiles.general.province')}
          form={form}
          provinces={this.props.provinces}
          locale={locale}
          identity="organization"
          required={true}
        />
        <PostalCodeField
          className=""
          initialValue={get(organization, 'profiles.general.postalCode')}
          form={form}
          label={true}
          country={country}
          identity="organization"
        />
        <CancelAndSaveButtons
          onClickCancel={this.handleCancel}
          onClickSave={this.showActionModal}
          isSavingInProgress={this.props.isUpdateConfigurationInProgress}
        />
        {modificationModal}
      </Form>
    );
  }
}

export default translate('TaxReceiptAdminConfigurationOrganizationDetailsForm')(
  TaxReceiptAdminConfigurationOrganizationDetailsForm
);
